import DeleteIcon from "@mui/icons-material/Delete";
import {
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const SortableTableCell = ({
  property,
  children,
  orderBy,
  sortOrder,
  onClick,
  active,
}) => {
  return (
    <TableCell onClick={() => onClick(property)}>
      <TableSortLabel
        active={orderBy === property}
        direction={sortOrder}
        sx={{
          "& .MuiTableSortLabel-icon": {
            color: "rgba(0,114,206,255) !important",
          },
        }}
      >
        <Box sx={{ color: active ? "rgba(0,114,206,255)" : "inherit" }}>
          {children}
        </Box>
      </TableSortLabel>
    </TableCell>
  );
};
const SkillDetails = ({
  courses,
  skillId,
  handleDeleteClick,
  enableSave,
  oneOffList,
  handleOneOfChange,
  handleSaveAPI,
}) => {
  const [sortOrder, setSortOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const handleSortClick = (property) => {
    const isAsc = orderBy === property && sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = courses
    ? courses.sort((a, b) => {
        const order = sortOrder === "asc" ? 1 : -1;
        let aValue =
          orderBy === "CREATED_DT" ? new Date(a[orderBy]) : a[orderBy];
        let bValue =
          orderBy === "CREATED_DT" ? new Date(b[orderBy]) : b[orderBy];
        if (
          (aValue === null || aValue === undefined) &&
          (bValue === null || bValue === undefined)
        ) {
          return 1;
        }
        // Handle null or undefined values
        if (aValue === null || aValue === undefined) {
          return order;
        }
        if (bValue === null || bValue === undefined) {
          return -order;
        }

        // Normal string comparison
        if (aValue < bValue) {
          return -1 * order;
        }
        if (aValue > bValue) {
          return 1 * order;
        }
        return 0;
      })
    : [];

  const handleConfirmCancel = () => {
    navigate(`/skill-mappings`);
  };
  const handleCancel = () => {
    setOpen(true);
  };

  const handleSave = () => {
    setIsSaveOpen(true);
  };
  const handleSaveConfirm = () => {
    handleSaveAPI();
    setIsSaveOpen(false);
  };

  return (
    <Box sx={{ ml: "22px", borderLeft: "1px solid #e0e0e0" }}>
      <Box sx={{ ml: "22px", mr: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box display={"flex"} alignItems={"center"}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Assigned Courses
            </Typography>
            <Badge
              badgeContent={courses?.length || 0}
              color="primary"
              sx={{ ml: 2 }}
            />
          </Box>
          <Box>
            <Button
              variant="text"
              color="primary"
              onClick={() => handleCancel()}
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ml: 2 }}
              disabled={!enableSave}
              onClick={() => handleSave()}
            >
              Save
            </Button>
          </Box>
        </Box>
        {/* <Alert severity="warning" sx={{mt:2}}>
  This Skill has additional requirements that are not listed here, Please contact your system administrator for more information.
</Alert> */}
        <TableContainer>
          <Box sx={{ maxHeight: "calc(100vh - 270px)", overflow: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <SortableTableCell
                    property="COURSE_ID"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "COURSE_ID"}
                  >
                    COURSE ID
                  </SortableTableCell>
                  <SortableTableCell
                    property="COURSE_NAME"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "COURSE_NAME"}
                  >
                    COURSE NAME
                  </SortableTableCell>
                  <SortableTableCell
                    property="ONE_OF"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "ONE_OF"}
                  >
                    ONE-OF
                  </SortableTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row) => (
                  <TableRow key={row.COURSE_ID}>
                    <TableCell>
                      <>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteClick(row)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        {row.COURSE_ID}
                      </>
                    </TableCell>
                    <TableCell>{row.COURSE_NAME}</TableCell>
                    <TableCell>
                      <Select
                        size="small"
                        value={row.ONE_OF || "None"}
                        sx={{ width: "150px" }}
                        onChange={(event) =>
                          handleOneOfChange(row, event.target.value)
                        }
                      >
                        {oneOffList.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                        <MenuItem value={"None"}>None</MenuItem>
                      </Select>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
      </Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">{"Are you sure you want to cancel"}</DialogTitle> */}
        <DialogContent sx={{ p: 6 }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              textAlign: "center",
            }}
          >
            <h3> Are you sure you want to cancel?</h3>
            Your edits will not be saved.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ m: 4, mt: 0, justifyContent: "center" }}>
          <Button
            onClick={() => setOpen(false)}
            color="primary"
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
          >
            No, Go Back
          </Button>
          <Button
            onClick={handleConfirmCancel}
            color="secondary"
            autoFocus
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isSaveOpen}
        onClose={() => setIsSaveOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">{"Are you sure you want to cancel"}</DialogTitle> */}
        <DialogContent sx={{ p: 6 }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              textAlign: "center",
            }}
          >
            <h3> Are you sure you want to save?</h3>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ m: 4, mt: 0, justifyContent: "center" }}>
          <Button
            onClick={() => setIsSaveOpen(false)}
            color="primary"
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
          >
            No, Go Back
          </Button>
          <Button
            onClick={handleSaveConfirm}
            color="secondary"
            autoFocus
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
          >
            Yes, Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SkillDetails;
